import { AbstractControl, Validators } from '@angular/forms';

export function validPasswordFormat( control: AbstractControl ) {
    if (control.value != null) {
        const pass = control.value;
        const valid = isValidPasswordFormat( pass ); // outputs true

        if ( !valid ) {
            return  { 'noValidPasswordFormat': true };
        } else {
            return null;
        }

    } else {
        return null;
    }
}

export function isValidPasswordFormat( password: string ): boolean {
    const regex = /^(?=.*[Aa-zZ])(?=.*[0-9]).{8,}/g;
    return regex.test(password);
}
